import {
  useCallback,
  useEffect,
  useState
} from "react";
import { useFormikContext } from "formik";
import { Button, Spinner } from "reactstrap";
import { detectRegistrationCountry } from "helpers/registrationCountryDetection";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 2000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(255, 255, 255, 0.82)",
};

const loaderStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 12,
  padding: "24px 32px",
  borderRadius: 8,
  background: "#fff",
  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
  maxWidth: 360,
  textAlign: "center",
};

const RegistrationCountryAutoDetect = ({ setCountryCode }) => {
  const { setFieldValue } = useFormikContext();
  const [isDetecting, setIsDetecting] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const detectCountry = useCallback(() => {
    let isMounted = true;

    setIsDetecting(true);
    setErrorMessage("");

    detectRegistrationCountry()
      .then((country) => {
        if (!isMounted) return;

        setCountryCode(country.phone[0]);
        setFieldValue("country", country.name, false);
        setIsDetecting(false);
      })
      .catch((error) => {
        if (!isMounted) return;

        setErrorMessage(error.message);
        setIsDetecting(false);
      });

    return () => {
      isMounted = false;
    };
  }, [setCountryCode, setFieldValue]);

  useEffect(() => detectCountry(), [detectCountry]);

  if (!isDetecting && !errorMessage) return null;

  return (
    <div style={overlayStyle} aria-live="polite" aria-busy={isDetecting}>
      <div style={loaderStyle}>
        {isDetecting ? <Spinner color="primary" /> : null}
        <span>{isDetecting ? "Detecting your country..." : errorMessage}</span>
        {!isDetecting && errorMessage ? (
          <Button color="primary" type="button" onClick={detectCountry}>
            Try again
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default RegistrationCountryAutoDetect;